import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import store from 'store2';
import { UserService } from '../../services/user.service';
import { CommonModule } from '@angular/common';
import { catchError, firstValueFrom, map, Observable, of, take, tap } from 'rxjs';
import { CompanyClinicService } from 'src/app/services/companyClinic.service';
import { PaymentGateway } from 'src/app/models/clinicParms/WorldnetEnum';
import { TokenHelperService } from 'src/app/services/token-helper.service';
import { DataStatusService } from 'src/app/services/data-status.service';
import { SpinnerComponent } from "../common/spinner/spinner.component";
import { ToastHelper } from '../common/toaster.helper';
import { isValueNullOrEmpty } from 'src/app/utilities/validation.utils';
import { ClinicPatientService } from 'src/app/services/clinic.patient.service';
import { MenuParams } from 'src/app/models/ParamModels/PatientNotesDetailParam';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule, SpinnerComponent, RouterModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent implements OnInit {

  forgetPassword = false;
  loading = false;
  reseting = false;
  @Input() error!: string | null;
  @Output() submitEM = new EventEmitter();
  formModel = { UserName: '', Password: '' }
  resetModel = { Email: '', LinkUrl: '' }
  isPasswordVisible: boolean = false;
  formSubmitted: boolean = false;

  constructor(private router: Router, private renderer: Renderer2, private userService: UserService,
    private _clinicPatientService: ClinicPatientService,
    private _companyClinicservice: CompanyClinicService, private tokenService: TokenHelperService, private _dataStatus: DataStatusService,
    private _toastr: ToastHelper, private cdr: ChangeDetectorRef
  ) {

  }

  ngOnInit(): void {

    this.BasicClassChanges();

    if (store('token') != null && this.tokenService.getSessionExpiryTime() > 15) {
      this.router.navigateByUrl('/home');
    }
    else {
      this.router.navigateByUrl('/login');
    }
  }


  OnSubmit(form: NgForm) {
    this.formSubmitted = true;
    this.loading = true;
    //console.log(form.value);

    if (form.value.UserName == '' && form.value.Password == '') {
      this._toastr.showWarning("Please enter Username and Password");
      this.loading = false;
      this.cdr.markForCheck();
      return;
    } else if (form.value.UserName == '') {
      this._toastr.showWarning("Please enter Username");
      this.loading = false;
      this.cdr.markForCheck();
      return;
    } else if (form.value.Password == '') {
      this._toastr.showWarning("Please enter Password");
      this.loading = false;
      this.cdr.markForCheck();
      return;
    }

    if (form.value.UserName != '' && form.value.Password != '') {
      this.userService.login(form.value).pipe(take(1)).subscribe(
        {
          next: (res: any) => {
            var result = res.body;
            //  Detect 202 (2FA required)
            if (res.status === 202) {
              console.log("2FA required", result);
              // save username + password temporarily for 2FA verification (sessionStorage only — cleared on tab close)
              store.session('pendingUser', form.value.UserName);
              store.session('pendingPass', form.value.Password);
              store.session('maskedPhone', result.maskedPhone);
              this._toastr.showInfo("2FA code sent to your phone");

              this.router.navigate(['/verify2fa'], {
                queryParams: { username: form.value.UserName }
              });
              this.loading = false;
              this.cdr.markForCheck();
              return;
            }
            //console.log("res", result);
            if (result == null) {
              // console.log('Something went wrong, try later.', 'Authentication failed.');
              this._toastr.showError("Something went wrong, try later");
              this.loading = false;
            }
            else if (result.token == "3001") {
              // console.log('Incorrect username or password.', 'Authentication failed.');
              this._toastr.showWarning("Incorrect username or password!");
              this.loading = false;
            }
            else if (result == 2003) {
              // console.log('Unable to login! Please contact your administrator.', 'Authentication failed.');
              this._toastr.showError("Unable to login! Please contact your administrator!");
              this.loading = false;
            }
            else if (result == 2002) {
              // console.log('Due to many attempts, your account is locked out. Kindly wait for 10 minutes and try again!', 'Authentication failed.');
              this._toastr.showError("Due to many attempts, your account is locked out. Kindly wait for 10 minutes and try again!");
              this.loading = false;
            }
            else {
              store('token', result.token);
              store('role', result.role);
              this._dataStatus.updateTokenTime(this.tokenService.getSessionExpiryTime());
              // if (result?.agency > 0) {
              //   store('AgencyID', result.agency);
              // }
              store('AgencyID', result?.agency);
              this.GetSystemUserInfo();
              // this.loading = false;
              //form.reset();
              // setTimeout(() => {
              //   this.router.navigateByUrl("/home");
              // }, 1000);
            }
            this.cdr.markForCheck();
          },
          error: err => {
            this.loading = false;
            if (err.status == 400)
              console.error('Incorrect username or password.', 'Authentication failed.');
            else if (err.status == 460)
              console.error('Invalid Request', 'Authentication failed.');
            else if (err.status == 500)
              console.error('Something went wrong, try later.', 'Authentication failed.');

            this.cdr.markForCheck();
            //this.Reset();
          }
        }
      );
      //store('token', form.value);
    }

  }

  GetSystemUserInfo() {
    var headingCalendar = false;
    var lUserName = this.formModel.UserName.toLowerCase();
    this.userService.GetSystemUserInfo(this.formModel.UserName).pipe(take(1)).subscribe(
      (res: any) => {
        res = res.filter(x => x.userName.toLowerCase() === lUserName);
        if (res != null && res.length > 0) {
          //console.log("res[0]",res[0]);
          store('firstName', res[0].firstName);
          store('lastName', res[0].lastName);
          store('userID', res[0].userID);
          store('companyID', res[0].companyID);
          store('roleID', res[0].roleID);
          store('userName', lUserName);
          store('newRoleId', res[0].newRoleId);
          store('newRoleName', res[0].newRoleName ?? '');

          if (res[0].googleCalendarCode != '' && res[0].googleCalendarCode != null) {
            store('IsGoogleCalendarCode', 1);
          }
          else {
            store('IsGoogleCalendarCode', 0);
          }
          if (res[0].isReleaseNotes == true && res[0].isReleaseNotes != null) {
            store('IsReleaseNotesCheck', 1);
          }
          else {
            store('IsReleaseNotesCheck', 0);
          }
          if (res[0].outlookCalendarCode != '' && res[0].outlookCalendarCode != null) {
            store('IsOutlookCalendarCode', 1);
          }
          else {
            store('IsOutlookCalendarCode', 0);
          }
          if (store('companyID') == '0') {
            store(false);
            return;
          }
          if (res[0].isCalendly == true && res[0].isCalendly != null) {
            store('isCalendlyCalendarCode', 1);
          }
          else {
            store('isCalendlyCalendarCode', 0);
          }
          if (res[0].roleID == 4) {
            headingCalendar = true;
            this.GetClinicOfficesByCompany(res[0].companyID).then(
              async (gcbres: any) => {
                if (gcbres) {
                  let clinicOfficeItems = store('clinicOffices');
                  store('totalBranches', clinicOfficeItems.map(function (x) { return x.branchID; }).join(','));
                  // if (isValueNullOrEmpty(store('userBranches'))) {
                  //   store('userBranches', clinicOfficeItems[0].branchID)
                  // }
                  store('userBranches', clinicOfficeItems[0].branchID);
                  await firstValueFrom(this.GetBranchWiseUserPermissions());

                  this.loading = false;
                  this.cdr.markForCheck();
                  this.router.navigateByUrl("/home");
                }
              });
          }
          else {
            this.GetClinicOfficesByCompany(res[0].companyID).then(
              (gcbres: any) => {
                if (gcbres) {
                  this.GetUserBranches(res).then(async (gubres: any) => {
                    if (gubres) {
                      this.setPaymentMethod();
                      await firstValueFrom(this.GetBranchWiseUserPermissions());

                      headingCalendar = true;
                      //this.router.navigate(['/cliniccalendar']);
                      this.loading = false;
                      this.cdr.markForCheck();
                      this.router.navigateByUrl("/home");
                    }
                  })
                }
              });
          }
        }
      },
      err => {
        //this.toastr.log('Locate user info failed! Please contact your administrator.', 'Locate User Info failed.');
      }
    );
  }

  async GetUserBranches(res: any): Promise<boolean> {
    var branches = "";
    if (res[0].userBranches != null && res[0].userBranches.length > 0) {
      res[0].userBranches.forEach(function (item, index) {
        if (branches == "") {
          branches = item.branchID + "";
        } else {
          branches = branches + "," + item.branchID;
        }
      }.bind(this));
      store('totalBranches', branches);

      // if (isValueNullOrEmpty(store('userBranches'))) {
      //   store('userBranches', branches.split(',')[0]);
      // }
      store('userBranches', branches.split(',')[0]);
      // console.log('Login', store('userBranches'));
      return true;
    } else {
      throw new Error('No user branches');
    }
  }

  async GetClinicOfficesByCompany(companyID: number): Promise<boolean> {
    try {
      const res: any = await firstValueFrom(
        this._companyClinicservice.GetClinicOfficesByCompany(companyID).pipe(take(1))
      );
      var clinicOfficeData = JSON.parse(res.data);
      //console.log("clinicOfficeData", clinicOfficeData);
      var clinicOfficeItems = [];
      if (clinicOfficeData.length > 0) {
        clinicOfficeData.forEach(item => {
          var clinicOfficeItem = {
            "branchID": item.BranchID,
            "branchName": item.BranchName,
            "paymentGateway": item.PaymentGateway
          }
          clinicOfficeItems.push(clinicOfficeItem);
        })
      }
      store('clinicOffices', clinicOfficeItems);
      //this.SetPaymentMethod();
      //console.log("clinicOffices", clinicOfficeItems);
      return true;
    } catch (err) {
      return false;
    }
  }
  GetBranchWiseUserPermissions(): Observable<boolean> {
    let menuParams = new MenuParams();
    menuParams.userID = store('userID');
    menuParams.branchID = store('userBranches');

    return this._clinicPatientService
      .GetBranchWiseUserPermissions(menuParams)
      .pipe(
        take(1),
        tap((res) => {
          if (res?.length > 0) {
            store('userPermissions', JSON.stringify(res));
          }
        }),
        map(() => true),
        catchError(err => {
          console.error('Error fetching user permissions', err);
          return of(false);
        })
      )
  }

  setPaymentMethod() {
    var clinicBranches = store('clinicOffices');
    var allowedBranches = store('userBranches');
    // var allowedBranchesList = allowedBranches.replaceAll(/\s/g,'').split(',');
    var allowedBranchesList = [allowedBranches];
    var branches = clinicBranches.filter(x => allowedBranchesList.includes(x.branchID.toString()))
    if (branches != null && branches.length > 0) {
      if (branches[0].paymentGateway == PaymentGateway.WORLDNET) {
        store('paymentGateway', 1);
        store('paymentGatewayP', PaymentGateway.WORLDNET);
      }
      else if (branches[0].paymentGateway == PaymentGateway.CARDCONNECT) {
        store('paymentGateway', 2);
        store('paymentGatewayP', PaymentGateway.CARDCONNECT);
      }
      else if (branches[0].paymentGateway == PaymentGateway.NMI) {
        store('paymentGateway', 3);
        store('paymentGatewayP', PaymentGateway.NMI);
      }
      else {
        store('paymentGateway', 0);
      }
      //console.log("this.paymentAPI", store('paymentGateway'));
    }
  }

  ResetPassword(form: NgForm) {
    alert(form.value.UserName);
  }

  forgotPassword() {
    this.forgetPassword = !this.forgetPassword;
  }

  BasicClassChanges() {
    this.renderer.removeClass(document.body, 'antialiased');
    this.renderer.removeClass(document.body, 'flex');
    this.renderer.removeClass(document.body, 'h-full');
    this.renderer.removeClass(document.body, 'demo1');
    this.renderer.removeClass(document.body, 'sidebar-fixed');
    this.renderer.removeClass(document.body, 'header-fixed');
    this.renderer.removeClass(document.body, 'bg-[#fefefe]');
    this.renderer.removeClass(document.body, 'dark:bg-coal-500');
    // this.renderer.addClass(document.body, 'flex');
    // this.renderer.addClass(document.body, 'h-full');
    // this.renderer.addClass(document.body, 'text-base');
  }

}
